import { backendFetch } from 'services/backend-auth';
import { normalizePostMedia, parseMediaReference } from 'services/media';
import AppModal from "components/Modal";
import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom"; 
import { useForm, Controller } from "react-hook-form";
import { useAuth } from '../../../helpers/authContext';
import { Button, Row, Col, Label, Input, Card, CardBody, FormGroup, Form } from 'reactstrap';
import useCategories from 'helpers/useCategories';
import AdvancedSettings from "components/AdvancedSettings";
import { postCreateWithWif } from "helpers/steem";
import { useNavigate } from 'react-router-dom';
import { postCreateKeychain } from "helpers/keychain";
import { getPostBody, isLoggedWithKeychain } from "services/dsteem-service";
import ImageUploader from "components/ImageUploader";
import IPFSUploader from "components/IPFSUploader";
import FullEditor from "components/FullEditor";
import renderer, { replaceIPFSVideoLinks } from 'helpers/contentRenderer';
import { renderHTMLSafe } from "services/posts-service";
import { get_ipfs_usage, update_ipfs_metadata, get_ipfs_metadata, aiBackend, get_user_preferences, get_user_templates, create_user_template, update_user_template, delete_user_template } from "services/db-service";
import { useToast } from "components/ui/use-toast";
import { cancelUpload } from "services/db-service";
import { clearUploadState, getUploadState } from "helpers/UploadState";
import { uploadManager } from "helpers/UploadContext";
import { removeVideo } from "helpers/UploadDB";
import aiIcon from "../../../assets/img/ai.svg";


import { isAuthorized, authorizeAccount, fetchScheduleAccount, SCHEDULE_ACCOUNT } from "services/authority-service";
import { backend } from "services/db-service";
import LoginModal from "../../user/userModals/LoginModal";
import { addPostingAuthorityKeychain } from "helpers/keychain";

type FormData = {
  link: string,
  title: string,
  cover?: string,
  description?: string,
  category?: string,
  tags?: any,
  video?: any,
//   display_type?:string
};

type Props = {
  community?: any,
  isShowing: boolean,
  hide: any,
  postToEdit?: any,
  onSuccess?: () => void
}

function validate(data: FormData, setErrorMessage, type = "external") {
  let validated = true;
  if (type == "external" || type == "ipfs") {
    console.log("validating video links"); 
    if (type == "external") {
        if (!data.link.includes("youtube.com") && !data.link.includes("youtu.be") && !data.link.includes("ipfs")) {
            console.log("validating yt or ipfs links");
            setErrorMessage("Use a YouTube link or an uploaded video.");
            validated = false;
        }
    }
  }
   
  if (!data.title) {
    console.log("validating title");
    setErrorMessage("Please add a title.");
    validated = false;
  }
  return validated;
}

export const ContentCreatePostModal = ({ community, isShowing, hide, postToEdit, onSuccess }: Props) => { 
    const { user, autologin, app_settings, updateAppSettings, post_draft, updatePostDraft } = useAuth();
    
    // Parse editing data if provided
    const editingData = postToEdit && postToEdit.post_data ? JSON.parse(postToEdit.post_data) : null;

    const { register, handleSubmit, setValue, watch, reset, getValues, control } = useForm<FormData>({
        defaultValues: {
            title: editingData?.title || post_draft.title || '',
            cover: editingData?.cover || post_draft.cover || '',
            description: editingData?.body || post_draft.description || '',
            tags: editingData?.tags ? (Array.isArray(editingData.tags) ? editingData.tags.join(' ') : editingData.tags) : (Array.isArray(post_draft.tags) ? post_draft.tags.join(' ') : post_draft.tags || 'steemvideo'),
            category: editingData?.category || community?.name || post_draft.category || "",
            link: editingData?.link || post_draft.link || '',
            // display_type: post_draft.display_type || 'video',
        },
        shouldUnregister: false
    });
    const { toast } = useToast();
    const [supportSpeak, setSupportSpeak] = useState<boolean>(
        editingData ? (editingData.options?.beneficiaries?.some((b: any) => b.account === 'speem') || false) : 
        (post_draft.supportSpeak !== undefined ? post_draft.supportSpeak : true)
    );
    const navigate = useNavigate();
    const [orientation, setOrientation] = useState<"clip" | "video">("clip");
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [editorType, setEditorType] = useState<string>(app_settings.editor || "");
    const [ipfsAccount, setIpfsAccount] = useState<any>({});
    const [link, setLink] = useState<string>(post_draft.link || "");
    const [isUploading, setIsUploading] = useState(false); 
    const [paused, setPaused] = useState(false);
    const [editorKey, setEditorKey] = useState(0);
    const [cancelUploadState, setCancelUploadState] = useState(false); 
    const [showConfirm, setShowConfirm] = useState(false);
    const [isPublishing, setIsPublishing] = useState(false);
    
    // Scheduled Posts states
    const [isScheduling, setIsScheduling] = useState(!!postToEdit);
    
    // Parse scheduled date properly for local datetime-local input
    let initScheduleDate = "";
    if (postToEdit && postToEdit.scheduled_at) {
        const d = new Date(postToEdit.scheduled_at);
        // Format to YYYY-MM-DDThh:mm
        initScheduleDate = new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
    } else {
        const d = new Date();
        d.setMinutes(d.getMinutes() + 30);
        initScheduleDate = new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
    }
    const [scheduleDate, setScheduleDate] = useState(initScheduleDate);
    const [showAuthConfirm, setShowAuthConfirm] = useState(false);
    const [isLoginModalShowing, setIsLoginModalShowing] = useState(false);
    const [requiredActive, setRequiredActive] = useState(false);
    const [scheduleAcc, setScheduleAcc] = useState(SCHEDULE_ACCOUNT);

    const toggleLoginModal = () => setIsLoginModalShowing(!isLoginModalShowing);

    const handleAuthorizeAndProceed = async (wif = "") => {
        setIsPublishing(true);
        try {
            if (isLoggedWithKeychain(autologin)) {
                const result: any = await addPostingAuthorityKeychain(user, scheduleAcc);
                if (result && result.success) {
                    toast({ title: "Success", description: "Authority granted! Proceeding with schedule...", variant: "wild_green" });
                    await handleSchedulePublish();
                } else {
                    toast({ title: "Error", description: result?.message || "Failed to authorize.", variant: "rose_red" });
                }
            } else {
                const res = await authorizeAccount(autologin, scheduleAcc, wif);
                if (res.success) {
                    toast({ title: "Success", description: "Authority granted! Proceeding with schedule...", variant: "wild_green" });
                    await handleSchedulePublish();
                } else {
                    toast({ title: "Error", description: res.message, variant: "rose_red" });
                }
            }
        } catch (e) {
            console.error(e);
        }
        setIsPublishing(false);
        setShowAuthConfirm(false);
    };
    
    const [finalPost, setFinalPost] = useState<any>(null);
    const [aiProcessing, setAiProcessing] = useState(false);
    const [aiStatus, setAiStatus] = useState('');
    const [aiInterval, setAiInterval] = useState<any>(null);
    const [localVideoFile, setLocalVideoFile] = useState<File | null>(null);
    const [advancedOptions, setAdvancedOptions] = useState<any>(() => {
        const draftAdvanced = editingData ? editingData.options : post_draft.advanced;
        if (draftAdvanced && Array.isArray(draftAdvanced.beneficiaries)) {
            // Remove speem beneficiary if editing, it's handled by supportSpeak state
            let benes = draftAdvanced.beneficiaries.filter((b: any) => b.account !== 'speem');
            
            // If we are editing, the DB saved the weight multiplied by 100, so we divide to show % in UI
            if (editingData) {
                benes = benes.map((b: any) => ({ ...b, weight: (parseInt(b.weight) / 100).toString() }));
            }
            
            if (benes.length === 0) benes = [{ account: '', weight: '' }];
            return { ...draftAdvanced, beneficiaries: benes };
        }
        return { rewards: '1', ...draftAdvanced, beneficiaries: [{ account: '', weight: '' }] };
    });

    const stopAI = () => {
        if (aiInterval) clearInterval(aiInterval);
        setAiProcessing(false);
        setAiStatus('');
    };

    // Smart Templates states and handlers
    const [templates, setTemplates] = useState<any[]>([]);
    const [isTemplatesModalShowing, setIsTemplatesModalShowing] = useState(false);
    const [templateMenu, setTemplateMenu] = useState<number>(1); // 1 = list, 2 = create
    const [newTemplateName, setNewTemplateName] = useState("");

    const fetchTemplates = async () => {
        if (!user) return;
        try {
            const data = await get_user_templates(user);
            setTemplates(data || []);
        } catch (error) {
            console.error("Error fetching templates:", error);
        }
    };

    useEffect(() => {
        if (isShowing && user) {
            fetchTemplates();
        }
    }, [isShowing, user]);

    const handleSaveTemplate = async () => {
        if (!newTemplateName.trim()) {
            toast({
                title: "Error",
                description: "Please enter a template name.",
                variant: "rose_red"
            });
            return;
        }
        
        try {
            const currentValues = getValues();
            const payload = {
                username: user,
                template_name: newTemplateName.trim(),
                title: currentValues.title || "",
                description: currentValues.description || "",
                category: currentValues.category || "",
                tags: currentValues.tags || ""
            };
            
            const res = await create_user_template(payload);
            if (res && !res.error) {
                toast({
                    title: "Success",
                    description: "Template saved successfully.",
                    variant: "wild_green"
                });
                setNewTemplateName("");
                setTemplateMenu(1);
                fetchTemplates();
            } else {
                toast({
                    title: "Error",
                    description: res?.message || "Failed to save template.",
                    variant: "rose_red"
                });
            }
        } catch (error: any) {
            toast({
                title: "Error",
                description: error?.message || "Failed to save template.",
                variant: "rose_red"
            });
        }
    };

    const handleDeleteTemplate = async (id: number, e: React.MouseEvent) => {
        e.stopPropagation();
        if (!window.confirm("Are you sure you want to delete this template?")) return;
        try {
            const res = await delete_user_template(id);
            if (res && !res.error) {
                toast({
                    title: "Success",
                    description: "Template deleted successfully.",
                    variant: "wild_green"
                });
                fetchTemplates();
            } else {
                toast({
                    title: "Error",
                    description: res?.message || "Failed to delete template.",
                    variant: "rose_red"
                });
            }
        } catch (error: any) {
            toast({
                title: "Error",
                description: error?.message || "Failed to delete template.",
                variant: "rose_red"
            });
        }
    };

    const handleSelectTemplate = async (tpl: any) => {
        let updatedTitle = tpl.title || "";
        let updatedDescription = tpl.description || "";
        let updatedTags = tpl.tags || "";
        let hasChanges = false;

        const processField = (val: string) => {
            if (!val) return { processed: val, originalUpdated: val, changed: false };
            let changed = false;
            const regex = /\[id=(\d+)\]/gi;
            const processed = val.replace(regex, (_match, numStr) => {
                changed = true;
                return numStr;
            });
            const originalUpdated = val.replace(regex, (_match, numStr) => {
                const nextNum = parseInt(numStr, 10) + 1;
                return `[id=${nextNum}]`;
            });
            return { processed, originalUpdated, changed };
        };

        const titleRes = processField(updatedTitle);
        const descRes = processField(updatedDescription);
        const tagsRes = processField(updatedTags);

        if (titleRes.changed || descRes.changed || tagsRes.changed) {
            hasChanges = true;
            updatedTitle = titleRes.originalUpdated;
            updatedDescription = descRes.originalUpdated;
            updatedTags = tagsRes.originalUpdated;
        }

        setValue("title", titleRes.processed, { shouldValidate: true, shouldDirty: true });
        setValue("description", descRes.processed, { shouldValidate: true, shouldDirty: true });
        setValue("category", tpl.category || "", { shouldValidate: true, shouldDirty: true });
        setValue("tags", tagsRes.processed, { shouldValidate: true, shouldDirty: true });

        setEditorKey(prev => prev + 1);

        if (hasChanges) {
            try {
                await update_user_template({
                    id: tpl.id,
                    template_name: tpl.template_name,
                    title: updatedTitle,
                    description: updatedDescription,
                    category: tpl.category || "",
                    tags: updatedTags
                });
                fetchTemplates();
            } catch (error) {
                console.error("Failed to update template increment", error);
            }
        }

        setIsTemplatesModalShowing(false);
        toast({
            title: "Template Loaded",
            description: `Loaded template "${tpl.template_name}" successfully.`,
            variant: "wild_green"
        });
    };


    // Unified sync function to avoid stale closures
    const syncDraft = (values?: any) => {
        const formValues = values || getValues();
        updatePostDraft({
            ...formValues,
            advanced: advancedOptions,
            supportSpeak
        });
    };

    // Auto-save form fields
    useEffect(() => {
        const subscription = watch((values) => {
            syncDraft(values);
        });
        return () => subscription.unsubscribe();
    }, [watch, advancedOptions, supportSpeak]);

    // Save when advancedOptions or supportSpeak change
    useEffect(() => {
        syncDraft();
    }, [advancedOptions, supportSpeak]);
    const rewardsMap: any = {
        "1": "SBD/SP",
        "2": "SP",
        "3": "Decline rewards"
    };
    const { categories, loading, error: catError } = useCategories();

    // Compute available categories by merging subscriptions with context/draft
    const availableCategories: any[] = [...categories];
    if (community?.name && !availableCategories.some(c => c[0] === community.name)) {
        availableCategories.unshift([community.name, community.title || community.name]);
    }
    if (post_draft.category && !availableCategories.some(c => c[0] === post_draft.category)) {
        availableCategories.push([post_draft.category, post_draft.category]);
    }
    const advancedSettingsRef = useRef<any>(null);
    const keychainLogin = isLoggedWithKeychain(autologin);
    let currentStep = 1;
    if (editorType == "pro") {
        currentStep = 3;
    }else if (editorType != "" && editorType != "pro") {
        currentStep = 2;
    }
    const [step, setStep] = useState<number>(currentStep);

    const handleNext = () => setStep((prev) => {
        let newPage = prev + 1;
        if (editorType == "pro" && prev == 1) {
            newPage = prev + 2;
        }
        return Math.min(newPage, 4);
    });
    const handleBack = () => setStep(prev => {
        let newPage = prev - 1;
        if (editorType == "pro" && prev == 3) {
            newPage = prev - 2;
        }
        return Math.max(newPage, 1);
    });
    const handleReset = ( ) => { 
        reset({
            title: '',
            cover: '',
            description: '',
            tags: '',
            category: '',
            link: '',
        });
        setLink("");
        setAdvancedOptions({ rewards: '1', beneficiaries: [] });
        setSupportSpeak(true);
        updatePostDraft({});

        setEditorKey(k => k + 1);
 
        setLink(''); 
        setStep(editorType == "pro"?3:2);
        // setOrientation("horizontal");
        setErrorMessage(null); 
        setIsUploading(false);
        setPaused(false);
        setShowConfirm(false);
        stopAI();
        setLocalVideoFile(null);
        updatePostDraft({
            title: '',
            cover: '',
            description: '',
            tags: [],
            category: '',
            link: '',
            display_type:"video"
        }); 
    };
    const handlePauseUpload = ( ) => { 
        if(isUploading){
            if(!window.confirm("Cancel current upload?")){
                return;
            }
        }  
        const state = getUploadState(); 
        if(state){
            console.log("Cancelling upload"); 
            clearUploadState(); 
            cancelUpload(state.uploadId);  
            uploadManager.remove(state.uploadId);
            setCancelUploadState(true); 
            setIsUploading(false);
            setPaused(false);
            removeVideo(state.uploadId);
        } else {
            setCancelUploadState(true); 
            setIsUploading(false);
            setPaused(false);
        }
    }; 

    const handleAIGenerated = (aiResult: any) => {
        const metadata = aiResult.ai_metadata;
        if (!metadata) return;

        if (metadata.seo_title) {
            setValue("title", metadata.seo_title, { shouldValidate: true, shouldDirty: true });
        }
        
        let desc = metadata.description || "";
        let tagsString = post_draft.tags || "";
        
        if (desc) {
            // Extraer hashtags para ponerlos en el array de tags.
            const tagsMatches = desc.match(/#[\w]+/g);
            if (tagsMatches && tagsMatches.length > 0) {
                let cleanTags = tagsMatches.map((t: string) => t.replace('#', '').toLowerCase()).join(' ');
                // Garantizar steemvideo de primero
                if (!cleanTags.includes("steemvideo")) cleanTags = "steemvideo " + cleanTags;
                tagsString = cleanTags;
                setValue("tags", tagsString, { shouldValidate: true, shouldDirty: true });
            } else {
                if (!tagsString.includes("steemvideo")) tagsString = "steemvideo " + tagsString;
                setValue("tags", tagsString, { shouldValidate: true, shouldDirty: true });
            }
            setValue("description", desc, { shouldValidate: true, shouldDirty: true });
        } else {
            if (!tagsString.includes("steemvideo")) tagsString = "steemvideo " + tagsString;
        }
        
        syncDraft();

        // Backup to the Database via endpoint
        const ipfsRegex = /\/ipfs\/([a-zA-Z0-9]+)/;
        const currentLink = getValues("link");
        const cidMatch = currentLink?.match(ipfsRegex) || post_draft?.link?.match(ipfsRegex);
        const cid = cidMatch ? cidMatch[1] : null;

        if (cid && user) {
            update_ipfs_metadata(
                cid, 
                metadata, 
                aiResult.transcription, 
                user,
                aiResult.language,
                aiResult.srt_content,
                aiResult.transcription_en,
                aiResult.srt_content_en
            );
        }
        
        toast({
            title: "🪄 Data populated!",
            description: "Your post fields were automatically filled by AI.",
            variant: "wild_green"
        });
    };

    const triggerBackgroundAI = (cid: string) => {
        if (!cid || !user) return;
        
        // Silently start the process

        
        backendFetch(`${aiBackend}/api/v1/process_ipfs`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 
                cid, 
                username: user, 
                generate_metadata: true,
            })
        })
        .then(res => res.json())
        .then(data => {
            if (data.task_id) {
                // Background polling
                const poll = setInterval(async () => {
                    try {
                        const res = await backendFetch(`${aiBackend}/api/v1/task/${data.task_id}`);
                        if (!res.ok) {
                            clearInterval(poll);
                            return;
                        }
                        const pollData = await res.json();
                        if (pollData.status === 'completed') {
                            const result = pollData.result;
                            update_ipfs_metadata(
                                cid, 
                                result.ai_metadata, 
                                result.transcription, 
                                user, 
                                result.language, 
                                result.srt_content,
                                result.transcription_en,
                                result.srt_content_en
                            );
                            clearInterval(poll);
                        } else if (pollData.status === 'failed') {
                            clearInterval(poll);
                        }
                    } catch (e) {
                         clearInterval(poll);
                    }
                }, 10000); // 10s is safer for background
            }
        })
        .catch(e => console.error("[Auto-AI] Silent trigger failed", e));
    };

    const generateAI = async () => {
        const selectedFile = localVideoFile;
        if (editorType !== "ipfs") return;
        setAiProcessing(true);
        setAiStatus('Checking existing cache...');

        const cid = parseMediaReference(link)?.cid;

        let existingTranscription = null;
        if (cid) {
            const cache = await get_ipfs_metadata(cid);
            if (cache && cache.transcription) {
                existingTranscription = cache.transcription;
            }
        }

        try {
            let res;
            let data;
            
            if (existingTranscription) {
                setAiStatus('Fast-tracking AI Engine...');
                res = await backendFetch(`${aiBackend}/api/v1/process_metadata_direct`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ transcription_text: existingTranscription, username: user || 'unknown', language: 'en' })
                });
                data = await res.json();
            } else {
                if (!selectedFile) {
                    setAiProcessing(false);
                    return toast({ title: "Local file missing", description: "Please re-select the video to extract audio.", variant: "rose_red" });
                }
                setAiStatus('Uploading to AI local engine...');

                const formData = new FormData();
                formData.append('video', selectedFile);
                formData.append('username', user || 'unknown');
                formData.append('generate_metadata', 'true');
                
                res = await backendFetch(`${aiBackend}/api/v1/process_video_direct`, {
                    method: 'POST',
                    body: formData
                });
                data = await res.json();
            }
            
            if (data.task_id) {
                setAiStatus('Processing...');
                const interval = setInterval(async () => {
                    try {
                        const poll = await backendFetch(`${aiBackend}/api/v1/task/${data.task_id}`);
                        const pollData = await poll.json();
                        if (pollData.status === 'completed') {
                            setAiStatus('Done!');
                            setAiProcessing(false);
                            handleAIGenerated(pollData.result);
                            clearInterval(interval);
                        } else if (pollData.status === 'failed') {
                            setAiStatus('');
                            setAiProcessing(false);
                            clearInterval(interval);
                            toast({ title: "AI Error", description: pollData.error, variant: "rose_red" });
                        } else {
                            const capitalized = pollData.status.charAt(0).toUpperCase() + pollData.status.slice(1);
                            setAiStatus(capitalized + '...');
                        }
                    } catch (e) {
                         console.error("Polling error", e);
                    }
                }, 4000);
                setAiInterval(interval);
            } else {
                setAiProcessing(false);
                setAiStatus('');
                toast({ title: "AI Error", description: data.message || "Failed to submit task", variant: "rose_red" });
            }
        } catch (e: any) {
            setAiProcessing(false);
            setAiStatus('');
            toast({ title: "AI Error", description: e.message, variant: "rose_red" });
        }
    };

    useEffect(() => { 
        const state = getUploadState(); 
        if (!state) return; 
        console.log(state); 
        if (state.active) {
            setIsUploading(true);
        }
    }, []);
    
    useEffect(() => {
        if (community && community.name) {
            setValue("category", community.name);
            syncDraft();
        }
    }, [community]); 

    useEffect(() => {
        register("cover");
        register("link");
        register("video");
    }, [register]);
    useEffect(() => {
        (async () => {
            const ipfs = await get_ipfs_usage(user); 
            setIpfsAccount(ipfs || []);
        })()
    }, []);
    useEffect(() => {
        if (isShowing && user && !postToEdit) {
            get_user_preferences(user).then((prefs) => {
                if (prefs && prefs.length > 0 && prefs[0].posting_preferences) {
                    try {
                        const parsed = JSON.parse(prefs[0].posting_preferences);
                        if (parsed.rewards) {
                            setAdvancedOptions((prev: any) => ({
                                ...prev,
                                rewards: parsed.rewards || '1',
                                beneficiaries: parsed.beneficiaries || [{ account: '', weight: '' }]
                            }));
                        }
                        if (parsed.orientation) {
                            setOrientation(parsed.orientation);
                        }
                        if (parsed.supportSpeak !== undefined) {
                            setSupportSpeak(parsed.supportSpeak);
                        }
                    } catch (e) {
                        console.error("Failed to parse posting preferences in modal", e);
                    }
                }
            }).catch(err => {
                console.error("Failed to fetch user preferences in modal", err);
            });
        }
    }, [isShowing, user, postToEdit]);
    useEffect(() => {
        updateAppSettings({autoplay:app_settings.autoplay, editor:editorType});
    }, [editorType]);

    useEffect(() => {
        if (editorType === "ipfs") {
            setValue("link", `${link}`);
            syncDraft();
        }
    }, [link]); 

    const onSubmit = (data: FormData) => {
        try { 
            const success = validate(data, setErrorMessage, editorType);
            if (data.tags && typeof data.tags == "string") {
                data.tags = data.tags.toLowerCase().replace(/#/g, "").split(' ');
            } 
            if (!data.category) {
                data.category = data.tags[0];
            }
            let options = JSON.parse(JSON.stringify(advancedSettingsRef.current.getOptionsComment()));
            
            // Apply supportSpeak directly to options so backend can schedule it correctly
            if (supportSpeak) {
                if (!options.beneficiaries) options.beneficiaries = [];
                const speemAcc = (process.env.SPEEM_BENEFICIARY_ACCOUNT)?.trim().toLowerCase().replace("@", "") || "speem";
                const speemWeight = (parseFloat(process.env.SPEEM_BENEFICIARY as any) || 10) * 100;
                
                const existing = options.beneficiaries.find((b: any) => b.account === speemAcc);
                if (existing) {
                    existing.weight = Math.max(existing.weight, speemWeight).toString();
                } else {
                    options.beneficiaries.push({ account: speemAcc, weight: speemWeight.toString() });
                }
            }

            let disabled = false;
            const post = {
                title: data.title,
                cover: data.cover,
                body: editorType == "pro"? data.description:getPostBody(data.cover, data.description, data.link),
                tags: data.tags || "",
                link: data.link,
                display_type: orientation,
                category: data.category || "",
                options
            };
            
            if (success && !disabled) { 
                setFinalPost(normalizePostMedia(post));
                setShowConfirm(true);
            } else{
                setErrorMessage("Fill all fields first");
            }
        } catch (error) {
            console.log(error);
            setErrorMessage("Something went wrong");
        }
    };

    const handleConfirmPublish = () => {
        setIsPublishing(true);
        const publish = keychainLogin
            ? () => postCreateKeychain(finalPost, user, supportSpeak)
            : () => postCreateWithWif(finalPost, autologin, supportSpeak);

        publish()
            .then((result: any) => {
                if (result.success) {
                    // Trigger Background AI if CID is detected (Link or Body for PRO mode)
                    const ipfsRegex = /\/ipfs\/([a-zA-Z0-9]+)/;
                    const cidMatch = finalPost?.link?.match(ipfsRegex) || finalPost?.body?.match(ipfsRegex);
                    const cid = cidMatch ? cidMatch[1] : null;
                    
                    if (cid) {
                        triggerBackgroundAI(cid);
                    }

                    // If we published a scheduled post immediately, delete the scheduled version
                    if (postToEdit?.id) {
                        backendFetch(`${backend}/api/v1/scheduled_post/${postToEdit.id}`, { method: 'DELETE' }).catch(e => console.error("Failed to delete scheduled post after immediate publish", e));
                    }

                    setShowConfirm(false);
                    hide();
                    handleReset();
                    if (onSuccess) onSuccess();
                    let urlType = "p";
                    navigate(`/${urlType}/${user}/${result.permlink}`);
                } else {
                    setErrorMessage(result.result.message);
                    setShowConfirm(false);
                }
                setIsPublishing(false);
            })
            .catch((err) => {
                console.log(err);
                setErrorMessage("Something went wrong.");
                setIsPublishing(false);
                setShowConfirm(false);
            });
    };

    const handleSchedulePublish = async () => {
        if (!scheduleDate) {
            toast({ title: "Error", description: "Select a date and time.", variant: "rose_red" });
            return;
        }

        const dateObj = new Date(scheduleDate);
        if (dateObj.getTime() <= Date.now()) {
            toast({ title: "Error", description: "Schedule time must be in the future.", variant: "rose_red" });
            return;
        }

        setIsPublishing(true);
        try {
            const acc = await fetchScheduleAccount();
            setScheduleAcc(acc);
            const authStatus = await isAuthorized(user, acc);
            if (!authStatus) {
                setIsPublishing(false);
                setShowAuthConfirm(true);
                return;
            }

            const utcDate = dateObj.toISOString();
            
            const endpoint = postToEdit?.id ? `${backend}/api/v1/scheduled_post/${postToEdit.id}` : `${backend}/api/v1/schedule_post`;
            const method = postToEdit?.id ? 'PUT' : 'POST';
            
            const res = await backendFetch(endpoint, {
                method: method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    username: user,
                    post_data: finalPost,
                    scheduled_at: utcDate
                })
            });
            const data = await res.json();
            
            if (data.success) {
                toast({ title: "Success", description: "Post scheduled successfully!", variant: "wild_green" });
                setShowConfirm(false);
                hide();
                handleReset();
                if (onSuccess) onSuccess();
            } else {
                toast({ title: "Error", description: data.error || "Failed to schedule", variant: "rose_red" });
            }
        } catch (e) {
            toast({ title: "Error", description: "Network error", variant: "rose_red" });
        }
        setIsPublishing(false);
    };
    let renderStep1, renderStep2, renderStep3, renderStep4;
    renderStep1 = (
        <div className="d-flex flex-column gap-3">
            {[
                { id: 'ipfs', icon: 'cloud-arrow-up', title: 'Direct Upload', desc: 'Upload videos with your Steem account.' },
                { id: 'external', icon: 'up-right-from-square', title: 'External Link', desc: 'Use YouTube or other external links.' },
                { id: 'pro', icon: 'code', title: 'PRO Editor', desc: 'Markdown and HTML tools.' }
            ].map(type => (
                <button key={type.id} className={`editor-button ${editorType === type.id ? 'active' : ''}`} 
                    onClick={(e) => { e.preventDefault(); setEditorType(type.id); if(type.id==='ipfs') setOrientation('clip'); else setOrientation('video'); }}>
                    <i className={`fas fa-${type.icon}`} />
                    <div className="text-center">
                        <strong>{type.title}</strong>
                        <p className="m-0 small text-muted">{type.desc}</p>
                    </div>
                </button>
            ))}
        </div>
    );

    renderStep2 = (
        <>
            {editorType === "ipfs" && <IPFSUploader key={editorKey} IpfsAccount={ipfsAccount} uploading={isUploading} setUploading={setIsUploading} setOrientation={setOrientation} paused={paused} setPaused={setPaused} cancelUploadState={cancelUploadState} onFileSelected={setLocalVideoFile} link={link} setLink={(l) => { setLink(l); setValue("link", l); }} />}
            {editorType === "external" && (
                <FormGroup>
                    <Label>Video Link:</Label>
                    <input className="form-control fancy-input" {...register("link")} />
                </FormGroup>
            )}
        </>
    );

    renderStep3 = (
        <div className="animate__animated animate__fadeIn">
            {editorType !== "pro" ? (
                <Row className="mb-2">
                    <Col md="12">
                        <FormGroup>
                            <Controller
                                name="category"
                                control={control}
                                render={({ field }) => (
                                    <Input 
                                        type="select" 
                                        className="form-control fancy-input" 
                                        {...field}
                                        disabled={loading}
                                        onChange={(e) => {
                                            field.onChange(e);
                                        }}
                                    >
                                        <option value="">Select community...</option>
                                        {availableCategories.map(cat => (
                                            <option key={cat[0]} value={cat[0]}>{cat[1]}</option>
                                        ))}
                                    </Input>
                                )}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="12"><FormGroup><input className="form-control fancy-input" placeholder="Title" {...register("title")} /></FormGroup></Col>
                    <Col md="4"><ImageUploader inputName="cover" defaultValue={getValues("cover")} register={register("cover")} setErrorMessage={setErrorMessage} onUpload={(url) => setValue("cover", url)} setValue={setValue} watch={watch} /></Col>
                    <Col md="8">
                        <FormGroup className="position-relative">
                            <textarea className="form-control fancy-input description-input" placeholder="Description" style={{ height: "133px" }} {...register("description")} />
                            {editorType === 'ipfs' && localVideoFile && (
                                <div style={{ position: 'absolute', bottom: 15, right: 10 }}>
                                    <Button 
                                        color="default" 
                                        size="sm" 
                                        onClick={(e) => { e.preventDefault(); generateAI(); }} 
                                        disabled={aiProcessing}
                                        style={{ borderRadius: '20px', display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 16px' }}
                                    >
                                        {aiProcessing ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                {aiStatus}
                                            </>
                                        ) : (
                                            <>
                                                <img src={aiIcon} alt="AI" style={{ width: '14px', height: '14px', filter: 'brightness(0) invert(1)' }} />
                                                AutoGen
                                            </>
                                        )}
                                    </Button>
                                </div>
                            )}
                        </FormGroup>
                    </Col>
                    <Col md="12"><FormGroup><input className="form-control fancy-input" placeholder="Tags" {...register("tags")} /></FormGroup></Col>
                </Row>
            ) : (
                <Row>
                    <Col className="col-9" md="9">
                        <FormGroup>
                            <Controller
                                name="category"
                                control={control}
                                render={({ field }) => (
                                    <Input 
                                        type="select" 
                                        className="form-control fancy-input" 
                                        {...field}
                                        disabled={loading}
                                        onChange={(e) => {
                                            field.onChange(e);
                                        }}
                                    >
                                        <option value="">Select community...</option>
                                        {availableCategories.map(cat => (
                                            <option key={cat[0]} value={cat[0]}>{cat[1]}</option>
                                        ))}
                                    </Input>
                                )}
                            />
                        </FormGroup>
                    </Col>
                    <Col className="col-3" md="3">
                        <Button 
                            className="directory-button w-100" 
                            color="secondary" 
                            onClick={() => {
                                setTemplateMenu(1);
                                setIsTemplatesModalShowing(true);
                            }}
                            style={{ height: "42px" }}
                            title="Templates"
                        >
                            <i className="fas fa-file-alt mr-md-2" />
                            <span className="d-none d-md-inline">Templates</span>
                        </Button>
                    </Col>
                    <Col md="12"><FormGroup><input className="form-control fancy-input" placeholder="Title" {...register("title")} /></FormGroup></Col> 
                    <Col md="12"><FullEditor key={editorKey} register={register} watch={watch} setValue={setValue} IpfsAccount={ipfsAccount} uploading={isUploading} setUploading={setIsUploading} setOrientation={setOrientation} cancelUploadState={cancelUploadState} paused={paused} setPaused={setPaused} /></Col>
                    <Col md="12"><FormGroup><input className="form-control fancy-input" placeholder="Tags" {...register("tags")} /></FormGroup></Col>
                </Row>
            )}
        </div>
    );
        let body = null;
        if (editorType == "pro") {
            try {
                let description = post_draft.description?.trim();
                let link = post_draft.link;
                if (description || link) {
                    if (link.includes("dweb.link")) {
                        description += `\n[IPFS Video](${link})`;
                    }else {
                        description += `\n${link}`;
                    }
                    
                    body = (
                        <div className="body-content">
                            {renderHTMLSafe(replaceIPFSVideoLinks(renderer.render(description)))}
                        </div>
                    );
                } else {
                    body = (
                    <div className="text-muted text-center py-5">
                        <i className="fas fa-eye-slash fa-2x mb-2" />
                        <p>No preview available.</p>
                    </div>
                    );
                }
            } catch (error) {
                setErrorMessage("Error rendering preview.");
                body = (
                    <div className="rose-red text-center py-5">
                    <p>Failed to render preview.</p>
                    </div>
                );
            }   
        }else {
            try {
                if (post_draft.link) {
                    let description = getPostBody(post_draft.cover, post_draft.description, post_draft.link);

                    if (description || link) {
                        if (description && description.includes('ipfs')) { 
                            const escapedUrl = description.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); 
                            description = description.replace(
                            new RegExp(`\\[IPFS Video\\]\\(${escapedUrl}\\)`, "gi"),
                            ""
                            ); 
                            description = description.replace(
                            new RegExp(`<a[^>]+href=["']${escapedUrl}["'][^>]*>.*?<\\/a>`, "gi"),
                            ""
                            );
                        } 
                        body = (
                            <div className="body-content">
                                {renderHTMLSafe(replaceIPFSVideoLinks(renderer.render(description)))}
                            </div>
                        );
                        
                    } else {
                        body = (
                        <div className="text-muted text-center py-5">
                            <i className="fas fa-eye-slash fa-2x mb-2" />
                            <p>No preview available.</p>
                        </div>
                        );
                    }
                }else {
                    body = (
                    <div className="text-muted text-center py-5">
                        <i className="fas fa-eye-slash fa-2x mb-2" />
                        <p>No preview available.</p>
                    </div>
                    );
                }
                
            } catch (error) {
                setErrorMessage("Error rendering preview.");
                body = (
                    <div className="rose-red text-center py-5">
                    <p>Failed to render preview.</p>
                    </div>
                );
            } 
        }

        useEffect(() => {
            if (errorMessage || catError) {
                toast({
                    title: "Ops! Something have failed.",
                    description: errorMessage || (typeof catError === 'string' ? catError : "An error occurred while fetching categories."),
                    variant:"rose_red"
                }); 
            }
        }, [errorMessage, catError]); 
        renderStep4 = ( 
            body 
        );
    // }, []); 
    
    renderStep4 = body;
    const progress = (step / (editorType === "pro" ? 3 : 4)) * 100;
    const item_width = 100 / (editorType === "pro" ? 3 : 4);

    const renderForm = (
        <div className="modal-body post-editor-body mt-0 p-0">
            <Card className="shadow border-0">
                <CardBody className="px-3 py-0 body-gray">
                    <div className="relative w-100 flex-shrink-0 mb-2">
                        <div className="post-way empty w-100"></div>
                        <div className="post-way filled" style={{ position: "absolute", top: 0, width: progress + "%" }}></div>
                        <div className={`step-name text-muted ${step >= 1 ? "active" : ""}`} onClick={() => setStep(1)} style={{ width: item_width + "%" }}>
                            Editor
                        </div>
                        <div className={`step-name text-muted text-center ${editorType === "pro" ? "d-none" : ""} ${step >= 2 ? "active" : ""}`} onClick={() => setStep(2)} style={{ width: item_width + "%" }}>
                            Upload
                        </div>
                        <div className={`step-name text-muted text-center ${step >= 3 ? "active" : ""}`} onClick={() => setStep(3)} style={{ width: item_width + "%" }}>
                            Details
                        </div>
                        <div className={`step-name text-muted text-right ${step >= 4 ? "active" : ""}`} onClick={() => setStep(4)} style={{ width: item_width + "%" }}>
                            Preview
                        </div>
                    </div>
                    <Form className="post-editor-wrapper" style={{ height: "auto", flex: 1, minHeight: 0 }}>
                        <div className="post-editor-scroll-area" style={{ minHeight: 0 }}>
                            <div style={{ display: step === 1 ? "block" : "none" }}>{renderStep1}</div>
                            <div style={{ display: step === 2 ? "block" : "none" }}>{renderStep2}</div>
                            <div style={{ display: step === 3 ? "block" : "none" }}>
                                <div className="animate__animated animate__fadeIn">
                                    {renderStep3}
                                    <div className="mt-2">
                                        <FormGroup check className="mb-2">
                                            <Label check><Input type="checkbox" checked={supportSpeak} onChange={(e) => setSupportSpeak(e.target.checked)} /> Support Speak on Steem?</Label>
                                        </FormGroup>
                                        <AdvancedSettings ref={advancedSettingsRef} options={advancedOptions} setOptions={setAdvancedOptions} orientation={orientation} setOrientation={setOrientation} supportSpeak={supportSpeak} author={user || ""} appSettings={app_settings} />
                                    </div>
                                </div>
                            </div>
                            <div style={{ display: step === 4 ? "block" : "none" }}>{renderStep4}</div>
                        </div>
                            <div className="post-editor-buttons mt-0">
                                {step > 1 && <Button disabled={isUploading || aiProcessing} color="secondary" onClick={handleBack}><i className="fas fa-chevron-left" /> Back</Button>}
                                {!isUploading && !aiProcessing && <Button color="secondary" onClick={handleReset}><i className="fas fa-trash" /> Clear</Button>}
                                {isUploading && <Button color="secondary" onClick={handlePauseUpload}><i className="fas fa-stop" /> Stop</Button>}
                                {step < 4
                                    ? <Button disabled={isUploading || isPublishing || aiProcessing} color="secondary" onClick={handleNext}>Next <i className="fas fa-chevron-right" /></Button>
                                    : <Button disabled={isUploading || isPublishing || aiProcessing} color="default" onClick={handleSubmit(onSubmit)}>{isPublishing ? <span className="spinner" /> : (keychainLogin ? "Post with Keychain" : "Post")}</Button>
                                }
                            </div>
                    </Form>
                </CardBody>
            </Card>
        </div>
    );

    return isShowing ? ReactDOM.createPortal(
        <>
            <AppModal isShowing={isShowing} hide={hide} size="lg" header="Video Studio">
                {renderForm}
            </AppModal>

            <AppModal isShowing={showConfirm} hide={() => !isPublishing && setShowConfirm(false)} size="md" header="Confirm Publication">
                <div className="p-3">
                    <p className="text-muted">Review your post details:</p>
                    <div className="mb-4 p-3 border rounded">
                        <div><strong>Rewards:</strong> {rewardsMap[finalPost?.options?.rewards]}</div>
                        {supportSpeak && (
                            <div className="d-flex align-items-center mt-2 p-2 rounded shadow-sm" style={{ borderLeft: "3px solid var(--speem)" }}>
                                <img src="https://steemitimages.com/u/speem/avatar" className="rounded-circle mr-2" style={{width: 30, height: 30}} />
                                <span className="flex-grow-1 font-weight-bold">speem <small className="text-muted">(Support)</small></span>
                                <span className="badge badge-speem">10%</span>
                            </div>
                        )}
                        {finalPost?.options?.beneficiaries?.map((b: any, i: number) => (
                            <div key={i} className="d-flex align-items-center mt-2 p-2 rounded shadow-sm">
                                <img src={`https://steemitimages.com/u/${b.account}/avatar`} className="rounded-circle mr-2" style={{width: 30, height: 30}} />
                                <span className="flex-grow-1 font-weight-bold">{b.account}</span>
                                <span className="badge badge-speem">{b.weight / 100}%</span>
                            </div>
                        ))}
                    </div>
                    <div className="d-flex gap-3 mb-3">
                        <Button color="secondary" className="w-100" onClick={() => setShowConfirm(false)}>Cancel</Button>
                        <Button color="default" className="w-100" onClick={handleConfirmPublish} disabled={isPublishing}>{isPublishing ? "Publishing..." : "Confirm"}</Button>
                    </div>
                    <Button color="info" outline className="w-100 mb-2" onClick={() => setIsScheduling(!isScheduling)} disabled={isPublishing}>
                        <i className="fas fa-clock mr-2" /> {isScheduling ? "Hide Schedule" : "Schedule for Later"}
                    </Button>
                    {isScheduling && (
                        <div className="mt-3 p-3 border rounded bg-light animate__animated animate__fadeIn">
                            <Label>Select Date and Time (Local):</Label>
                            <Input 
                                type="datetime-local" 
                                value={scheduleDate}
                                onChange={(e) => setScheduleDate(e.target.value)}
                                className="mb-2"
                            />
                            <Button color="speem" className="w-100" onClick={handleSchedulePublish} disabled={isPublishing}>
                                {isPublishing ? "Scheduling..." : "Schedule Post"}
                            </Button>
                        </div>
                    )}
                </div>
            </AppModal>

            <AppModal 
                isShowing={showAuthConfirm} 
                hide={() => !isPublishing && setShowAuthConfirm(false)} 
                size="md" 
                header="Authorization Required"
            >
                <div className="p-4 text-center">
                    <div className="mb-4">
                        <i className="fas fa-key text-speem" style={{ fontSize: '3.5rem' }} />
                    </div>
                    <h4 className="mb-3">Authorize Scheduling</h4>
                    <p className="text-muted mb-4">
                        To schedule posts, you need to grant posting authority to <strong>@{scheduleAcc}</strong>. 
                        This allows our bot to publish your post at the specified time.
                    </p>
                    <div className="d-flex justify-content-center gap-3">
                        <Button color="secondary" outline onClick={() => setShowAuthConfirm(false)} disabled={isPublishing}>
                            Cancel
                        </Button>
                        <Button color="speem" onClick={() => {
                            if (isLoggedWithKeychain(autologin)) {
                                handleAuthorizeAndProceed();
                            } else {
                                setRequiredActive(true);
                                toggleLoginModal();
                            }
                        }} disabled={isPublishing}>
                            {isPublishing ? <><i className="fas fa-spinner fa-spin" /> Authorizing...</> : "Authorize & Schedule"}
                        </Button>
                    </div>
                    {!isLoggedWithKeychain(autologin) && (
                        <p className="text-muted small mt-3">
                            * You will be asked for your <strong>Active Key</strong>.
                        </p>
                    )}
                </div>
            </AppModal>

            <AppModal 
                isShowing={isTemplatesModalShowing} 
                hide={() => setIsTemplatesModalShowing(false)} 
                size="md" 
                header="Post Templates"
            >
                <div className="modal-body post-editor-body p-0">
                    <Card className="no-shadow border-0">
                        {templateMenu === 1 && (
                            <>
                                <CardBody className="px-lg-3 py-lg-3 body-gray" style={{ marginBottom: "50px" }}>
                                    <Row>
                                        <Col md="12" className="mb-3">
                                            <p className="promotion-description">
                                                Select a template to pre-load configuration (Title, Body, Community, Tags).
                                            </p>
                                        </Col>
                                        <Col md="12" style={{ maxHeight: "350px", overflowY: "auto" }}>
                                            {templates.map((tpl, index) => (
                                                <div 
                                                    key={"template-" + tpl.id + "-" + index} 
                                                    className="directory-item mb-3 d-flex align-items-center justify-content-between p-2 rounded cursor-pointer"
                                                    onClick={() => handleSelectTemplate(tpl)}
                                                    style={{ border: "1px solid #ddd", background: "#fcfcfc" }}
                                                >
                                                    <div className="d-flex align-items-center">
                                                        <span className="directory-icon mr-3" style={{ fontSize: "1.2rem", color: "#666" }}>
                                                            <i className="fas fa-file-alt" />
                                                        </span>
                                                        <span className="directory-info d-flex flex-column">
                                                            <span className="directory-name font-weight-bold" style={{ color: "#333" }}>{tpl.template_name}</span>
                                                            <span className="directory-content text-muted small" style={{ maxWidth: "300px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                                                {tpl.title || "No Title"}
                                                            </span>
                                                        </span>
                                                    </div>
                                                    <Button 
                                                        color="danger" 
                                                        size="sm" 
                                                        outline 
                                                        onClick={(e) => handleDeleteTemplate(tpl.id, e)}
                                                        title="Delete Template"
                                                        style={{ padding: "0.25rem 0.5rem" }}
                                                    >
                                                        <i className="fas fa-trash-alt" />
                                                    </Button>
                                                </div>
                                            ))}
                                            {templates.length === 0 && (
                                                <div className="text-center py-4 text-muted">No templates saved yet.</div>
                                            )}
                                        </Col>
                                    </Row>
                                </CardBody>
                                <div className="post-editor-buttons mt-0">
                                    <Button color="secondary" onClick={() => setIsTemplatesModalShowing(false)}>
                                        <i className="fas fa-times mr-2" /> Close
                                    </Button>
                                    <Button color="default" onClick={() => setTemplateMenu(2)}>
                                        <i className="fas fa-plus mr-2" /> Save Current Post
                                    </Button>
                                </div>
                            </>
                        )}
                        {templateMenu === 2 && (
                            <>
                                <CardBody className="px-lg-3 py-lg-3 body-gray" style={{ marginBottom: "50px" }}>
                                    <Row>
                                        <Col md="12" className="mb-2">
                                            <p className="promotion-description">
                                                Save the current form state (Title, Body, Community, Tags) as a new template.
                                            </p>
                                        </Col>
                                        <Col md="12">
                                            <FormGroup>
                                                <div className="input-icon-group">
                                                    <i className="fas fa-id-card input-icon" />
                                                    <input 
                                                        type="text" 
                                                        className="form-control fancy-input" 
                                                        placeholder="Template Name (e.g. Daily Vlog)" 
                                                        value={newTemplateName} 
                                                        onChange={(e) => setNewTemplateName(e.target.value)} 
                                                    />
                                                </div>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </CardBody>
                                <div className="post-editor-buttons mt-0">
                                    <Button color="secondary" onClick={() => setTemplateMenu(1)}>
                                        <i className="fas fa-chevron-left mr-2" /> Back
                                    </Button>
                                    <Button color="default" onClick={handleSaveTemplate}>
                                        <i className="fas fa-save mr-2" /> Save
                                    </Button>
                                </div>
                            </>
                        )}
                    </Card>
                </div>
            </AppModal>

            <LoginModal 
                isShowing={isLoginModalShowing} 
                hide={toggleLoginModal} 
                requiredActive={requiredActive}
                onSuccess={(res: any) => {
                    setRequiredActive(false);
                    if (res && res.wif) {
                        handleAuthorizeAndProceed(res.wif);
                    }
                }}
            />
        </>, document.body
    ) : null;
};

export default ContentCreatePostModal;
